export default {
  All: 'all',
  Audit: 'audit',
  Price: 'price',
  RangeOfBarcodes: 'rangeOfBarcodes',
  RangeOfBinLocations: 'rangeOfBinLocations',
  Custom: 'custom',
}
